// TODO: #646 refactor -- refactor files structure

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import CircularProgress from 'material-ui/CircularProgress';
import { watermarkType } from '@molecules/Watermark/prop-types';
import TranscriptPage from '@layout/TranscriptPage';
import { TRANSCRIPT_VIEW_TYPES } from '@config/transcriptViewConfig';
import RULES from '@config/rules-constants';
import _ from 'lodash';
import { TranscriptHeader } from '@organisms';
import { Transcript } from './Transcript';
import messages from './messages';

const NotFoundContainer = styled.h1`
  text-align: center;
  font-size: 16pt;
  margin-bottom: 40px;
`;

export default class TranscriptView extends PureComponent {
  state = {
    hasError: false,
  };

  componentDidCatch(err) {
    this.props.logError(err.message, err.stack);
    this.setState({ hasError: true });
  }

  conditionalView() {
    const {
      conference: { isFetching, id },
    } = this.props;
    if (isFetching) return this.renderLoading();
    if (!id) return this.renderNotFound();
    if (this.state.hasError) return this.renderFailedToLoadTranscript();
    return <Transcript {...this.props} />;
  }

  renderFailedToLoadTranscript = () => {
    return (
      <TranscriptPage.Container className="transcript-container">
        <NotFoundContainer id="failed-to-fetch-transcript">
          <FormattedMessage {...messages.failed} />
        </NotFoundContainer>
      </TranscriptPage.Container>
    );
  };

  renderNotFound = () => {
    return (
      <TranscriptPage.Container className="transcript-container">
        <NotFoundContainer id="not-found-container">
          <FormattedMessage {...messages.notFound} />
        </NotFoundContainer>
      </TranscriptPage.Container>
    );
  };

  renderLoading = () => {
    return (
      <NotFoundContainer>
        <CircularProgress />
      </NotFoundContainer>
    );
  };

  render() {
    const {
      conference: { title, date },
      watermark,
      token,
      isAIRoute,
    } = this.props;

    const recordings = _.get(this.props.conference, 'recordings', []);
    const organization = _.get(this.props.conference, 'organization', null);
    const organizationRules = _.get(this.props.conference, 'organization.rules', []);
    const isOrganizationAllowDownloadRecordings =
      organization &&
      organizationRules.some(({ code }) => code === RULES.DOWNLOAD_CALL_RECORDINGS);
    const isThereRecordingsToDownload = recordings.length >= 1;
    const shouldShowAudioDownloadButton =
      isOrganizationAllowDownloadRecordings && isThereRecordingsToDownload;

    return (
      <TranscriptPage.Page>
        <Helmet>
          <title>
            {title || ''}&nbsp;—&nbsp;{date}
          </title>
        </Helmet>
        <TranscriptHeader
          downloadFileName={title}
          token={token}
          watermark={watermark}
          isAIRoute={isAIRoute}
          shouldShowAudioDownloadButton={shouldShowAudioDownloadButton}
        />
        <TranscriptPage.DocumentWrapper>
          {this.conditionalView()}
        </TranscriptPage.DocumentWrapper>
      </TranscriptPage.Page>
    );
  }
}

TranscriptView.propTypes = {
  token: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  conference: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    date: PropTypes.string,
    discussionPoints: PropTypes.array,
    readingList: PropTypes.object,
    isFetching: PropTypes.bool,
  }),
  isAIRoute: PropTypes.bool,
  watermark: PropTypes.oneOfType([watermarkType, PropTypes.bool]),
  mode: PropTypes.oneOf([
    TRANSCRIPT_VIEW_TYPES.FULL,
    TRANSCRIPT_VIEW_TYPES.ADMIN_PREVIEW,
    TRANSCRIPT_VIEW_TYPES.CLIENT_PREVIEW,
  ]).isRequired,
  isFetching: PropTypes.bool,
  logError: PropTypes.func,
};



// WEBPACK FOOTER //
// ./components/templates/TranscriptView/TranscriptView.component.js